module.exports = __webpack_public_path__ + "images/icons/size-guide/boat-icon.svg";